module.exports = __webpack_public_path__ + "static/media/items.b99cf275.jpg";